@if (activeLearnerUserLoaded()) {
	<lb-calendar-week-view [events]="lessonEvents()" (navigation)="calendarNav($event)" [configuration]="calendarConfiguration"></lb-calendar-week-view>
}
